import styled from 'styled-components';

export const CompanyInfoPanel = styled.div`
  width: 100%;
  max-width: 820px;

  display: flex;
  align-items: flex-start;
  gap: var(--space-m);

  margin: 0 auto var(--space-l);
  padding: var(--space-l);

  background: rgba(253, 220, 94, 0.08);

  border: 1px solid rgba(253, 220, 94, 0.3);
  border-radius: 14px;

  @media screen and (max-width: 600px) {
    gap: var(--space-s);

    margin-bottom: var(--space-m);
    padding: var(--space-m);
  }
`;

export const CompanyInfoIcon = styled.div`
  width: 40px;
  height: 40px;
  min-width: 40px;

  display: flex;
  align-items: center;
  justify-content: center;

  background: rgba(253, 220, 94, 0.22);
  color: var(--orange4);

  border-radius: 10px;

  svg {
    font-size: 0.9rem;
  }

  @media screen and (max-width: 600px) {
    width: 34px;
    height: 34px;
    min-width: 34px;

    border-radius: 8px;

    svg {
      font-size: 0.8rem;
    }
  }
`;

export const CompanyInfoContent = styled.div`
  min-width: 0;
  width: 100%;

  display: flex;
  flex-direction: column;
  gap: var(--space-m);
`;

export const CompanyInfoHeader = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.25rem;

  > span {
    color: var(--orange4);

    font-size: 0.68rem;
    font-weight: 800;
    letter-spacing: 0.07em;
    line-height: 1.2;
    text-transform: uppercase;
  }

  h3 {
    margin: 0;

    color: var(--grey7);

    font-size: 1.1rem;
    font-weight: 800;
    line-height: 1.3;
  }

  p {
    max-width: 650px;

    margin: 0.15rem 0 0;

    color: var(--grey5);

    font-size: 0.84rem;
    line-height: 1.6;
  }

  @media screen and (max-width: 600px) {
    h3 {
      font-size: 1rem;
    }

    p {
      font-size: 0.78rem;
      line-height: 1.55;
    }
  }
`;

export const CompanyInfoFeatures = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: var(--space-s) var(--space-l);

  padding: var(--space-m) 0;

  border-top: 1px solid rgba(253, 220, 94, 0.22);
  border-bottom: 1px solid rgba(253, 220, 94, 0.22);

  @media screen and (max-width: 650px) {
    grid-template-columns: 1fr;

    gap: var(--space-xs);
  }
`;

export const CompanyInfoFeature = styled.div`
  min-width: 0;

  display: flex;
  align-items: center;
  gap: var(--space-xs);

  color: var(--grey6);

  font-size: 0.78rem;
  font-weight: 650;
  line-height: 1.4;

  svg {
    flex: 0 0 auto;

    color: var(--green5);

    font-size: 0.65rem;
  }
`;

export const CompanyInfoNote = styled.p`
  margin: 0;

  color: var(--grey4);

  font-size: 0.76rem;
  font-weight: 550;
  line-height: 1.55;

  @media screen and (max-width: 600px) {
    font-size: 0.72rem;
  }
`;
